/**
 * Marquee selection in Stage coordinates (extracted from `upp-floor-plan` for tests).
 */

/** AABB from two opposite corners of a drag rectangle. */
export function floorPlanMarqueeBoxFromOpposingCorners(
  start: { x: number; y: number },
  end: { x: number; y: number },
): { x: number; y: number; width: number; height: number } {
  const x1 = Math.min(start.x, end.x);
  const y1 = Math.min(start.y, end.y);
  const x2 = Math.max(start.x, end.x);
  const y2 = Math.max(start.y, end.y);
  return { x: x1, y: y1, width: x2 - x1, height: y2 - y1 };
}

/** Matches host rule: ignore release when both dimensions are below minimum (Konva hit slop). */
export function floorPlanMarqueeBoxTooSmall(
  box: { width: number; height: number },
  minW = 3,
  minH = 3,
): boolean {
  return box.width < minW && box.height < minH;
}

/** Squared distance threshold before creating the marquee rect (default 4 px radius). */
export function floorPlanMarqueeDragExceedsStartThreshold(
  dx: number,
  dy: number,
  thresholdSq = 16,
): boolean {
  return dx * dx + dy * dy >= thresholdSq;
}
